var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-observer", { ref: "form" }, [
    _c("div", { staticClass: "rounded p-4" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12 mb-3" }, [
          _c("em", { staticClass: "fas fa-plus-circle text-orange mr-1" }),
          _c("span", { staticClass: "color-gray-7 font-weight-bold font-16" }, [
            _vm._v(" Documentación ")
          ])
        ]),
        _c("div", { staticClass: "col-12 col-md-4" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-input", {
                          attrs: {
                            id: "letter-secretary-name",
                            "custom-error-msg":
                              "nombre del Secretario(a) asociado(a) es requerido.",
                            error: errors[0],
                            label: "Secretario(a) asociado(a)",
                            max: 120,
                            placeholder: "Nombre del Secretario(a) Asociado(a)"
                          },
                          model: {
                            value: _vm.secretaryName,
                            callback: function($$v) {
                              _vm.secretaryName = $$v
                            },
                            expression: "secretaryName"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "col-md-12" }, [
          _c(
            "div",
            { staticClass: "d-flex justify-content-end align-items-center" },
            [
              _c(
                "action-button",
                {
                  attrs: {
                    id: "modal-btn-cancelar",
                    i: "fas fa-times-circle",
                    variant: "outline-danger mr-2"
                  },
                  on: {
                    click: function($event) {
                      return _vm.cancelHandler()
                    }
                  }
                },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "action-button",
                {
                  attrs: { i: "fa fa-save", variant: "success pl-4 pr-4" },
                  on: {
                    click: function($event) {
                      return _vm.saveHandler()
                    }
                  }
                },
                [_vm._v(" Guardar ")]
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }